import React, { useState } from "react";
import { Tabs, Tab, IconButton, Box } from "@mui/material";
import { PlaylistAdd } from "@mui/icons-material";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import { useTheme } from "@mui/material/styles";
import { withAuth } from "../../hoc";
import AddVideoComponent from "./AddVideo";
import VideoTable from "./VideoList";
import { addVideoBoxStyles, videoListBoxStyles } from "./css";
import ViewVideoComponent from "./ViewVideo";
import PlayList from "./Playlist";
import AddPlayListDrawer from "./AddPlaylist";
import ViewPlayList from "./ViewPlayList";

const Content = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [showAddVideo, setShowAddVideo] = useState<boolean>(false);
  const [showViewVideo, setShowViewVideo] = useState<boolean>(false);
  const [showPlayList, setShowViewPlayList] = useState<boolean>(false);
  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [selectedPlayList, setSelectedPlayList] = useState<string>("");

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleAddVideoClick = () => {
    setShowAddVideo(true);
  };

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };
  return (
    <>
      {/* Add Video Component */}
      {showAddVideo && !showViewVideo && !showPlayList && (
        <AddVideoComponent setShowAddVideo={setShowAddVideo} />
      )}

      {/* View Video Component */}
      {!showAddVideo && !showPlayList && showViewVideo && (
        <ViewVideoComponent
          setShowViewVideo={setShowViewVideo}
          selectedVideo={selectedVideo}
        />
      )}
      {/* View PlayList Component */}
      {!showAddVideo && !showViewVideo && showPlayList && (
        <ViewPlayList
          setShowViewPlayList={setShowViewPlayList}
          selectedPlayList={selectedPlayList}
        />
      )}

      {/* Tab Navigation and Action Buttons */}
      {!showAddVideo && !showViewVideo && !showPlayList && (
        <>
          <Box sx={addVideoBoxStyles}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label="Videos" />
              <Tab label="PlayLists" />
            </Tabs>
            <Box>
              <IconButton aria-label="add playlist" onClick={openDrawer}>
                <PlaylistAdd sx={{ color: theme.palette.secondary.main }} />
              </IconButton>
              <IconButton aria-label="add videos" onClick={handleAddVideoClick}>
                <VideoCallIcon sx={{ color: theme.palette.secondary.main }} />
              </IconButton>
            </Box>
          </Box>
          <AddPlayListDrawer
            open={drawerOpen}
            onClose={closeDrawer}
            setSelectedTab={setSelectedTab}
          />
          {/* Render Video or Playlist based on selected tab */}
          <Box style={videoListBoxStyles}>
            {selectedTab == 0 && (
              <VideoTable
                setSelectedVideo={setSelectedVideo}
                setShowViewVideo={setShowViewVideo}
              />
            )}

            {selectedTab == 1 && (
              <PlayList
                drawerOpen={drawerOpen}
                setShowViewPlayList={setShowViewPlayList}
                setSelectedPlayList={setSelectedPlayList}
              />
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default withAuth(Content);
